import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { VNZImageEntity } from "~/interfaces/entities/VNZImage"
import { vnzImages } from "~/redux/state/VNZImages"
import { useVNZAuthenticationState } from "./useVNZAuthenticationState"
import { useVNZService } from "./useVNZService"

export const useVNZImageActions = () => {
  const dispatch = useDispatch()
  const {
    state: { accessToken },
  } = useVNZAuthenticationState()

  const vnzService = useVNZService()

  // Stable identity so React.memo'd grid cells don't re-run their load effect
  // on every parent render.
  const loadVNZImageThumbnail = useCallback(
    async (image: VNZImageEntity) => {
      dispatch(vnzImages.actions.loadThumbnailForImage({ id: image.id }))
    },
    [dispatch]
  )

  // Clear the terminal "no more pages" flag so a retry can fetch again
  // (an empty page sets hasMore to false, which blocks all later fetches).
  const resetVNZImagesPagination = useCallback(() => {
    dispatch(vnzImages.actions.setHasMore(true))
  }, [dispatch])

  const loadVNZFullImage = async (image: VNZImageEntity) => {
    dispatch(
      vnzImages.actions.updateOne({
        id: image.id,
        changes: { isLoadingFullImage: true },
      })
    )
    const fullImageLocalUrl = await vnzService.fetchFullImage(
      accessToken,
      image
    )
    dispatch(
      vnzImages.actions.updateOne({
        id: image.id,
        changes: {
          isLoadingFullImage: false,
          hasLoadedFullImage: true,
          fullImageLocalUrl,
        },
      })
    )

    return fullImageLocalUrl
  }

  return {
    loadVNZImageThumbnail,
    loadVNZFullImage,
    resetVNZImagesPagination,
  }
}
